import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    refreshToken({ commit }, accessToken) {
      commit('refreshToken', accessToken);
    },
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
    verifyEmail({ commit }, payload) {
      return AuthService.verifyEmail(payload.email, payload.code).then(
        response => {
          commit('verifyEmailSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    resendOtp(context, email) {
      return AuthService.resendOtp(email).then(
        response => {
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    refreshToken(state, accessToken) {
      state.status.loggedIn = true;
      state.user = { ...state.user, accessToken: accessToken };
    },
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    verifyEmailSuccess(state) {
      if (state.user) {
        state.user.emailVerified = true;
        // Also update local storage so page reload doesn't wipe it out
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
          storedUser.emailVerified = true;
          localStorage.setItem('user', JSON.stringify(storedUser));
        }
      }
    },
    updateUser(state, userDetails) {
      if (state.user) {
        if (state.user.email !== userDetails.email) {
          state.user.emailVerified = false;
        }
        state.user.email = userDetails.email;

        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
          if (storedUser.email !== userDetails.email) {
            storedUser.emailVerified = false;
          }
          storedUser.email = userDetails.email;
          localStorage.setItem('user', JSON.stringify(storedUser));
        }
      }
    }
  }
};